export default class AnchorsPlugin {
  dom: HTMLElement;
  stickybutton: HTMLElement;
  closebutton: HTMLElement;
  target: HTMLElement;
  outer: HTMLElement;
  anchors: HTMLAnchorElement[];
  links: HTMLAnchorElement[];
  observer?: IntersectionObserver;
  cache?: Map<string, IntersectionObserverEntry>;
  opt: any;

  constructor(dom: HTMLElement, o: any) {
    this.dom = dom;
    this.stickybutton = document.querySelector<HTMLElement>('.menu-sticky-navbar.js-toggle');
    this.closebutton = document.querySelector<HTMLElement>('.navigation-close');
    this.outer = document.querySelector<HTMLElement>('.article-nav-outer');
    this.anchors = Array.from(document.querySelectorAll<HTMLAnchorElement>('a[emk-class="anchor"]'));
    this.links = Array.from(document.querySelectorAll<HTMLAnchorElement>('a[class="article-nav-link"]'));
    this.cache = new Map<string, IntersectionObserverEntry>();

    const defaults = {};

    this.opt = {
      ...defaults,
      ...o,
    };
  }

  init() {
    this.observer =
      this.observer ??
      new IntersectionObserver((intersectedEls) => {
        intersectedEls.forEach((el) => {
          el.target.setAttribute('name', el.target.getAttribute('name').replaceAll(' ', '%20'));
          this.cache.set(el.target.getAttribute('name'), el);
        });
        const selectedEl = Array.from(this.cache.values())
          .filter((el) => el.isIntersecting)
          .map((el) => <HTMLElement>el.target)
          .toSorted((a, b) => a.offsetTop - b.offsetTop)
          .at(0);
        this.selectAnchor(selectedEl);
      });

    this.anchors.forEach((el) => {
      this.observer.observe(el);
    });

    // Manage sticky/anchors menu click
    this.stickybutton?.addEventListener('click', () => {
      this.switchPageStyle('scroll');
    });
    this.closebutton?.addEventListener('click', () => {
      this.switchPageStyle();
    });
    this.outer?.addEventListener('click', () => {
      this.switchPageStyle();
    });
    Array.from(this.links).forEach((source) => {
      source.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToPoint(source);
      });
    });
  }

  selectAnchor(el: HTMLElement) {
    this.links.forEach((e) => e.classList.remove('selected'));
    this.links.find((e) => e.dataset.name === el?.getAttribute('name'))?.classList.add('selected');
  }

  goToPoint(el: HTMLElement) {
    const attr = el.dataset.name;
    const targetElement = document.querySelector<HTMLElement>(`a[emk-class="anchor"][name="${attr}"]`);
    if (el.dataset.name === 'Overview') {
      targetElement.style.setProperty('scroll-margin-top', '8.5em');
    } else {
      targetElement.style.setProperty('scroll-margin-top', '5.5em');
    }
    targetElement.scrollIntoView({ behavior: 'smooth' });
    this.switchPageStyle();
  }

  switchPageStyle(mode = 'auto') {
    document.querySelector<HTMLElement>('body').style.overflow = mode;
    if (mode === 'scroll') {
      this.dom.classList.add('centered');
      this.outer.classList.add('visible');
      const contentElement = document.querySelector<HTMLElement>('.content');
      contentElement.classList.add('pk-position--relative');
      contentElement.appendChild(this.outer);
      this.outer.classList.add('pk-position--absolute');
      this.outer.style.setProperty('z-index', '3');
    } else {
      this.dom.classList.remove('centered');
      this.outer.classList.remove('visible');
      this.outer.style.removeProperty('top');
      const contentElement = document.querySelector<HTMLElement>('.content');
      contentElement.classList.remove('pk-position--relative');
      contentElement.removeChild(this.outer);
      this.outer.classList.remove('pk-position--absolute');
      this.outer.style.setProperty('z-index', '999');
    }
  }
}
